import {Box, IconButton, List, Typography} from "@mui/material";
import {AddCircle} from "@mui/icons-material";
import {SubtitleCue} from "./SubtitleCue";
import {ICue} from "./LocalizedSubtitles";
import {ProjectDetails} from "../../redux/types/firebase";
import {useEffect, useState} from "react";
import {makeWebVTTFile} from "../../utility/track";

interface IEditSubtitles {
    blockName: string
    cues: ICue []
    onAddCue: () => void
    onDeleteCue: (index: number) => void
    onMoveCue: (from: number, to: number) => void
    onUpdateCue: () => void
    project: ProjectDetails
}
export function EditSubtitles({blockName, cues, onAddCue, onDeleteCue, onMoveCue, onUpdateCue, project}: IEditSubtitles) {
    const [trackUrl, setTrackUrl] = useState<string>();
    const pathElements = blockName.split("_");
    const path = blockName[0] === "e" ? pathElements.slice(0, 2).join("/") : pathElements[0];
    const videoUrl = `${project.videoSource}/${path}/${blockName}.mp4`;

    useEffect(() => {
        if (cues.length) {
            setTrackUrl(`data:text/plain;base64,${Buffer.from(makeWebVTTFile(cues))
                .toString("base64")}`);
        } else {
            setTrackUrl(undefined);
        }
    }, [cues]);
    return (
        <Box display="flex" flexDirection="column">
            <video controls>
                <source src={videoUrl} type={"video/mp4"}/>
                {trackUrl && <track default kind="captions" srcLang="en/GB" src={trackUrl}/>}
            </video>
            <Box display="flex">
                <Typography variant="h6" sx={{flexGrow: 1}}>Cues</Typography>
                <IconButton color="primary" onClick={onAddCue}>
                    <AddCircle/>
                </IconButton>
            </Box>
            <List disablePadding>
                {cues.map((cue, index) =>
                    <SubtitleCue count={cues.length} cue={cue} index={index} onDelete={onDeleteCue}
                                 onMove={onMoveCue} onUpdate={onUpdateCue} key={index}/>
                )}
            </List>
        </Box>
    );
}
